export default "__VITE_ASSET__Dp_wFwWY__"